export default {
  settingAuthorize: {
    header: {
      name: '物流商名称',
      business: '物流业务名称',
      type: '接口类型',
      channel: '平台类型',
    },

    authorized: '物流授权配置',

    table: {
      name: '物流商名称',
      business: '物流业务名称',
      type: '接口类型',
      channel: '平台类型(渠道)',
      obtain: '自动获取',
      default: '是否默认',
      warehouse: '使用仓库',
      template: '面单模板',
      linkMan: '面单联系人',
      phone: '面单联系手机',
      address: '面单地址',
    },

    addAndEdit: {
      title: '物流授权配置',
      authorized: '授权配置',
      logistics: '系统物流商',
      business: '系统物流业务',
      logisticsText: '请先选择所属物流商',
      interface: '接口类型',
      channel: '平台类型(渠道)',
      authorizeTitle: '使用店铺账号授权',
      defaultType: '设为默认接口类型',
      shipment: '开启自动获取物流单号',
      useWarehouse: '使用仓库',
      addWarehouse: '添加仓库',
      interfaceMsg: '接口信息',
      tooltipText: '获取单号时，优先匹配订单平台类别，未匹配则使用默认接口类型',

      table: {
        warehouseCode: '仓库编码',
        warehouseName: '仓库名称',
        code: '网点编码',
        name: '网点名称',
        cardNumber: '月结卡号',
        address: '发货地址',
        electronicForm: '电子面单可用数',
        defaultAddress: '默认地址',
        business: '物流业务类型',
      },

      print: '打印配置',
      downloadPrint: '下载打印组件',
      standardTemplate: '云打印标准模板',
      selectStandardTemplate: '请选择云打印标准模板',
      printTemplate: '云打印自定义模板',
      sender: '面单寄件人',
      sendMobile: '面单寄件手机',
      sendAddress: '面单寄件地址',
      addressText: '请输入详细地址',
      address: '详细地址',
      tips: '（请与店铺后台填写的寄件地址保持一致，防止获取运单失败）',
      rulesLogisticsCompany: '请选择系统物流商',
      rulesLogisticsBusiness: '请选择系统物流业务',
      rulesInterfaceType: '请选择接口类型',
      rulesChannelList: '请请选择平台类别(渠道)',
      rulesShop: '请选择使用店铺账号授权',
      rulesSender: '请选择面单寄件人',
      rulesSendMobile: '请输入面单寄件手机',
      rulesCallback1: '请选择省/市/区',
      rulesCallback2: '请输入详细地址',
      msgError: '请选择使用仓库'
    }
  }
};
